import React from 'react';
import { MapContainer, TileLayer,Marker,Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import L from 'leaflet';


const ErbilMap = () => {
  const customIcon = new L.Icon({
    iconUrl: 'https://leafletjs.com/examples/custom-icons/leaf-red.png',
    iconSize: [38, 95],
    iconAnchor: [22, 94],
    popupAnchor: [-3, -76],
  });
    const center = [36.19256397201926, 44.012087021301895]; // Default map center (latitude, longitude)
  const locations = [
    
    { name: 'عوينات علي', position: [36.19535602520032, 44.00505002532275] },
    { name: 'عوينات سيد احمد', position: [36.19875451225072, 44.035874514549995] },
      { name: 'مجمع ملائكة الرحمة', position: [36.19906304278299, 44.03589368285931] }



    








  ];
  return (
    <MapContainer center={center} zoom={11} style={{ height: '100vh', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      {locations.map((loc, idx) => (
        <Marker key={idx} position={loc.position} icon={customIcon }>
          <Popup>{loc.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default ErbilMap;
